import { CommonModule } from '@angular/common';
import { Component, inject, OnDestroy, OnInit } from '@angular/core';
import {
	FormBuilder,
	FormGroup,
	Validators,
	ReactiveFormsModule,
	AbstractControl,
} from '@angular/forms';
import { Auth } from '../../utils/auth.model';
import { AuthService } from '../../services/auth.service';
import { ErrorManagerService } from '../../services/error-manager.service';
import { AppException } from '../../shared/exceptions/app.exception';
import { Subject, Subscription, takeUntil } from 'rxjs';
import { LocalStorageService } from '../../services/localstorageService.service';
import {
	noEmailValidator,
	pswCharacterControl,
} from '../../shared/validator/password.validator';
import { ModalService } from '../../services/modal.service';

@Component({
	selector: 'app-modal-login',
	imports: [CommonModule, ReactiveFormsModule],
	templateUrl: './modal-login.component.html',
	styleUrl: './modal-login.component.css',
})
export class ModalLoginComponent implements OnInit, OnDestroy {
	private readonly authService = inject(AuthService);
	private readonly errorManagerService = inject(ErrorManagerService);
	private readonly localStorageService = inject(LocalStorageService);
	private readonly modalService = inject(ModalService);

	private readonly destroy$ = new Subject<void>();
	errors: AppException = { errorCode: 0, errorMessage: '' } as AppException;
	errorSubscription!: Subscription;

	isLoginForm: boolean = true;
	recuperaPassword: boolean = false;
	registerSuccesful: boolean = false;
	infoSuccess: boolean = false;
	rememberMe = this.localStorageService.getRememberMe();

	loginForm!: FormGroup;
	registerForm!: FormGroup;
	lostPassword!: FormGroup;

	get passwordRegisterControl(): AbstractControl {
		return this.registerForm.get('password') as AbstractControl;
	}

	constructor(private fb: FormBuilder) {}

	ngOnInit() {
		this.initForms();
	this.errorManagerService
		.getError$()
		.pipe(takeUntil(this.destroy$))
		.subscribe((error) => {
			this.errors = error;
		});
	if (this.rememberMe === 'true') {
		this.loginForm.get('rememberMe')?.patchValue(true);
	}
	}

	ngOnDestroy() {}

	private initForms(): void {
		this.loginForm = this.fb.group({
			username: ['', Validators.required],
			password: ['', Validators.required],
			rememberMe: [false],
		});
		this.registerForm = this.fb.group({
			username: [
				'',
				Validators.compose([Validators.required, noEmailValidator]),
			],
			email: ['', [Validators.required, Validators.email]],
			password: [
				'',
				Validators.compose([Validators.required, pswCharacterControl]),
			],
		});

		this.lostPassword = this.fb.group({
			email: ['', [Validators.required, Validators.email]],
		});
	}

	recuperaPasswords(recuperaPassword: boolean) {
		this.infoSuccess = false;
		this.recuperaPassword = recuperaPassword;
		this.errors = {} as AppException;;
	}

	showLogin(): void {
		this.infoSuccess = false;
		this.isLoginForm = true;
		this.errors = {} as AppException;;
		this.registerSuccesful = false;
	}

	showRegister(): void {
		this.infoSuccess = false;
		this.isLoginForm = false;
		this.errors = {} as AppException;;
	}

	togglePassword(field: string): void {
		const input = document.getElementById(field) as HTMLInputElement;
		if (input) {
			input.type = input.type === 'password' ? 'text' : 'password';
		}
	}

	onLoginSubmit(): void {
		if (this.loginForm.invalid) return;
		const auth = this.loginForm.value as Auth;
		this.authService.login(auth);
	}

	onRegisterSubmit(): void {
		this.errors = {} as AppException;
		this.registerSuccesful = false;
		if (this.registerForm.valid) {
			const auth = this.registerForm.value as Auth;
			this.authService.registerUser(auth, (success) => {
				if (success) {
					this.registerSuccesful = true;
				}
			});
		}
	}

	lostPasswordSubmit() {
		this.authService.restorePassword(this.lostPassword.value).subscribe({
			next: (res) => {
				this.infoSuccess = true
			},
			error: (err) => {
				console.error('Errore durante il ripristino della password', err);
			},
		});
	}
	closeModal() {
		this.infoSuccess = false;
		this.isLoginForm = true;
		this.recuperaPassword = false;
		if (this.errorSubscription) {
			this.errorSubscription.unsubscribe();
		}
		this.errors = {} as AppException;
		this.registerForm.reset();
		this.lostPassword.reset();
		this.loginForm.reset();

		this.registerSuccesful = false;
	}
}
